import { z } from 'zod';

export const TalentSearchSortingSchema = z.object({
  sortBy: z.string().max(255).nullable(),
});

export type TalentSearchSorting = z.infer<typeof TalentSearchSortingSchema>;
